import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: string; output: string; }
  ContactEmailScalar: { input: any; output: any; }
  GridStringArrayScalar: { input: any; output: any; }
  ISO8601Date: { input: string; output: string; }
  ISO8601DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Url: { input: string; output: string; }
};

export type AccessRole = {
  __typename?: 'AccessRole';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPersisted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum AccountColour {
  Col1 = 'COL1',
  Col2 = 'COL2',
  Col3 = 'COL3',
  Col4 = 'COL4',
  Col5 = 'COL5',
  Col6 = 'COL6',
  Col7 = 'COL7',
  Col8 = 'COL8',
  Col9 = 'COL9',
  Col10 = 'COL10',
  ColDefault = 'COL_DEFAULT'
}

export type BlockPage = {
  __typename?: 'BlockPage';
  /** @deprecated No longer used */
  content: Maybe<Scalars['String']['output']>;
  contentInBinary: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  iconCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  position: Maybe<Scalars['Int']['output']>;
};

export type BlockPageContent = {
  __typename?: 'BlockPageContent';
  contentInBinary: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type BlockPageList = {
  __typename?: 'BlockPageList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pages: Array<BlockPage>;
};

export type BounceCount = {
  __typename?: 'BounceCount';
  count: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isLimitReached: Scalars['Boolean']['output'];
  state: BounceStateEnum;
};

export enum BounceStateEnum {
  No = 'NO',
  Some = 'SOME',
  Yes = 'YES'
}

export type Campaign = {
  __typename?: 'Campaign';
  allowContinuousResend: Scalars['Boolean']['output'];
  analytics: Maybe<CampaignAnalytics>;
  attachment: Maybe<File>;
  clickTracking: Scalars['Boolean']['output'];
  continuous: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  /** @deprecated Use sender { email } instead */
  fromEmail: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  openTracking: Scalars['Boolean']['output'];
  project: Maybe<Project>;
  projectUrl: Scalars['String']['output'];
  recipientList: Maybe<List>;
  recipientListView: Maybe<ListView>;
  scheduledAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  sender: Maybe<Sender>;
  sentAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: CampaignStatus;
  subject: Maybe<Scalars['String']['output']>;
  templateHtml: Maybe<Scalars['String']['output']>;
  templateJson: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usageMode: Maybe<CampaignUsage>;
};

export type CampaignAnalytics = {
  __typename?: 'CampaignAnalytics';
  clickThroughRate: Scalars['Int']['output'];
  /** @deprecated Use percent_failed instead */
  percentBounced: Scalars['Int']['output'];
  percentClicked: Scalars['Int']['output'];
  percentComplained: Scalars['Int']['output'];
  percentDelivered: Scalars['Int']['output'];
  percentFailed: Scalars['Int']['output'];
  percentOpened: Scalars['Int']['output'];
  percentSkipped: Scalars['Int']['output'];
  percentUnsubscribed: Scalars['Int']['output'];
  totalAccepted: Scalars['Int']['output'];
  /** @deprecated Use total_failed instead */
  totalBounced: Scalars['Int']['output'];
  totalClicked: Scalars['Int']['output'];
  totalComplained: Scalars['Int']['output'];
  totalDelivered: Scalars['Int']['output'];
  totalFailed: Scalars['Int']['output'];
  totalOpened: Scalars['Int']['output'];
  totalRecipients: Scalars['Int']['output'];
  totalSkipped: Scalars['Int']['output'];
  totalUnsubscribed: Scalars['Int']['output'];
};

export type CampaignRecipientUnsubscribeData = {
  __typename?: 'CampaignRecipientUnsubscribeData';
  unsubscribeDomain: Maybe<Scalars['String']['output']>;
};

export type CampaignRecipientVariable = {
  __typename?: 'CampaignRecipientVariable';
  key: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type CampaignRecipientVariables = {
  __typename?: 'CampaignRecipientVariables';
  entries: Array<CampaignRecipientVariable>;
};

export enum CampaignStatus {
  /** All active campaigns */
  Active = 'ACTIVE',
  /** Campaign has been archived */
  Archived = 'ARCHIVED',
  /** Campaign is in draft mode */
  Draft = 'DRAFT',
  /** Campaign has been schedule to be sent */
  Scheduled = 'SCHEDULED',
  /** Campaign is currently sending */
  Sending = 'SENDING',
  /** Campaign has been sent */
  Sent = 'SENT'
}

export enum CampaignUsage {
  /** Campaign is not in use anywhere */
  None = 'NONE',
  /** Campaign belongs to a project */
  Project = 'PROJECT'
}

export type CareerCompany = {
  __typename?: 'CareerCompany';
  company: Maybe<Company>;
  companyDisplayName: Scalars['String']['output'];
  companyId: Maybe<Scalars['ID']['output']>;
  companyLinkedinUrl: Maybe<Scalars['Url']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  currentStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  jobTitles: Array<ContactJobTitle>;
};

export type Clean = {
  __typename?: 'Clean';
  /** Whether this list has been completely cleaned at some point in the past */
  beenCleaned: Scalars['Boolean']['output'];
  cleanEnd: Maybe<Scalars['ISO8601DateTime']['output']>;
  cleanStart: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  percentComplete: Scalars['Int']['output'];
  /** Overall status of the cleaning process */
  status: Maybe<ExecutionStatus>;
  totalBounced: Scalars['Int']['output'];
  totalConsentNotGiven: Scalars['Int']['output'];
  totalHighRisk: Scalars['Int']['output'];
  totalLowRisk: Scalars['Int']['output'];
  totalMediumRisk: Scalars['Int']['output'];
  totalMembers: Scalars['Int']['output'];
  totalUnengaged: Scalars['Int']['output'];
  totalUnsubscribed: Scalars['Int']['output'];
};

export type ColumnConditionOutput = {
  __typename?: 'ColumnConditionOutput';
  operation: ColumnFilterOperationEnum;
  value: Maybe<Scalars['String']['output']>;
  valueTo: Maybe<Scalars['String']['output']>;
};

export enum ColumnFilterOperationEnum {
  Blank = 'BLANK',
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  False = 'FALSE',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  InRange = 'IN_RANGE',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotBlank = 'NOT_BLANK',
  NotContains = 'NOT_CONTAINS',
  NotEqual = 'NOT_EQUAL',
  NotInRange = 'NOT_IN_RANGE',
  StartsWith = 'STARTS_WITH',
  True = 'TRUE'
}

export type ColumnFilterOutput = {
  __typename?: 'ColumnFilterOutput';
  columnName: Scalars['String']['output'];
  columnUid: Scalars['ID']['output'];
  conditions: Array<ColumnConditionOutput>;
  joinOperator: ColumnJoinOperatorEnum;
};

export enum ColumnJoinOperatorEnum {
  And = 'AND',
  Or = 'OR'
}

export type ColumnsFilteringOutput = {
  __typename?: 'ColumnsFilteringOutput';
  filters: Array<ColumnFilterOutput>;
  joinOperator: ColumnJoinOperatorEnum;
};

export type Company = {
  __typename?: 'Company';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canManageRelationshipPartners: Scalars['Boolean']['output'];
  companyHierarchy: CompanyHierarchy;
  companyType: CompanyCustomType;
  companyTypes: Array<CompanyCustomType>;
  contacts: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  documents: Array<CompanyDocument>;
  domain: Maybe<Scalars['String']['output']>;
  domains: Array<Scalars['String']['output']>;
  externalIdentifier: Maybe<ExternalIdentifier>;
  hasCustomLogo: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  info: CompanyInfo;
  insightStat: InsightStat;
  interactionsLast: LastAts;
  interactionsTotal: Totals;
  isBlocked: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  isSubDomainCompany: Scalars['Boolean']['output'];
  lastReferralSource: Maybe<Contact>;
  lastYearDepartmentsStats: Array<LastYearCompanyDepartmentStat>;
  logoUrl: Maybe<Scalars['String']['output']>;
  monthlyEngagement: Array<CompanyMonthlyInteractionDist>;
  openOpportunityCount: Scalars['Int']['output'];
  opportunityStats: OpportunityStat;
  pendingTaskCount: Scalars['Int']['output'];
  referredOpportunityStats: OpportunityStat;
  /** @deprecated use relationshipPartners */
  relationshipPartner: Maybe<Employee>;
  relationshipPartners: Maybe<Array<Employee>>;
  reporting: CompanyReporting;
  /** @deprecated Use company_types */
  secondaryTypes: Array<CompanyCustomType>;
  upcomingMeetingCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type CompanyLogoUrlArgs = {
  preferIdenticonFallback?: InputMaybe<Scalars['Boolean']['input']>;
  size?: Scalars['Int']['input'];
};

export type CompanyCard = {
  __typename?: 'CompanyCard';
  domain: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CompanyCustomType = {
  __typename?: 'CompanyCustomType';
  defaultType: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  typeName: Scalars['String']['output'];
};

export type CompanyDetail = {
  __typename?: 'CompanyDetail';
  companyTypes: Maybe<Scalars['GridStringArrayScalar']['output']>;
  correspondenceEmails: Maybe<Scalars['GridStringArrayScalar']['output']>;
  correspondenceNumbers: Maybe<Scalars['GridStringArrayScalar']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryNames: Maybe<Scalars['GridStringArrayScalar']['output']>;
  internalIndustryNames: Maybe<Scalars['GridStringArrayScalar']['output']>;
  linkedinUrl: Maybe<Scalars['String']['output']>;
  numberOfEmployees: Maybe<Scalars['Int']['output']>;
  primaryLocation: Maybe<CompanyOfficeLocationGrid>;
  tags: Scalars['GridStringArrayScalar']['output'];
  twitterUrl: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

export type CompanyDocument = {
  __typename?: 'CompanyDocument';
  file: Maybe<File>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['Url']['output']>;
};

export type CompanyForCustomField = {
  __typename?: 'CompanyForCustomField';
  domain: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info: CompanyInfoForCustomField;
  logoUrl: Maybe<Scalars['String']['output']>;
};

export type CompanyGrid = {
  __typename?: 'CompanyGrid';
  domain: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryNames: Array<Scalars['String']['output']>;
  internalIndustryNames: Array<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  monthlyEngagement: Array<CompanyMonthlyInteractionDist>;
  name: Scalars['String']['output'];
  typeName: Scalars['String']['output'];
  typeNames: Array<Scalars['String']['output']>;
};

export type CompanyHierarchy = {
  __typename?: 'CompanyHierarchy';
  company: Company;
  customFields: Array<CustomField>;
  hierarchy: Maybe<Hierarchy>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  parent: Maybe<Company>;
  position: Scalars['Int']['output'];
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  correspondenceEmails: Maybe<Array<Scalars['String']['output']>>;
  correspondenceNumbers: Maybe<Array<Scalars['String']['output']>>;
  description: Maybe<Scalars['String']['output']>;
  headquarterLocation: Maybe<CompanyOfficeLocation>;
  id: Maybe<Scalars['ID']['output']>;
  industryNames: Maybe<Array<Scalars['String']['output']>>;
  internalIndustries: Maybe<Array<InternalIndustry>>;
  internalIndustryNames: Maybe<Array<Scalars['String']['output']>>;
  linkedinUrl: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
  name: Scalars['String']['output'];
  numberOfEmployees: Maybe<Scalars['Int']['output']>;
  primaryLocation: Maybe<CompanyOfficeLocation>;
  tags: Array<Scalars['String']['output']>;
  twitterUrl: Maybe<Scalars['String']['output']>;
  website: Maybe<Scalars['String']['output']>;
};

export type CompanyInfoForCustomField = {
  __typename?: 'CompanyInfoForCustomField';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanyListItem = {
  __typename?: 'CompanyListItem';
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  memberCustomFields: Maybe<Array<CustomFieldSchema>>;
  name: Scalars['String']['output'];
  project: Maybe<Project>;
  reminderSettings: Array<ReminderSetting>;
  tabUid: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usageMode: CompanyUsageModeInput;
};

export type CompanyMonthlyInteractionDist = {
  __typename?: 'CompanyMonthlyInteractionDist';
  interactionCount: Scalars['Int']['output'];
  month: Scalars['String']['output'];
};

export type CompanyOfficeLocation = {
  __typename?: 'CompanyOfficeLocation';
  companyOfficeLocationId: Scalars['ID']['output'];
  headquarter: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  labels: Array<Scalars['String']['output']>;
  location: Location;
  primary: Scalars['Boolean']['output'];
};

export type CompanyOfficeLocationGrid = {
  __typename?: 'CompanyOfficeLocationGrid';
  brief: Scalars['String']['output'];
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  isHeadquarter: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Maybe<Scalars['Boolean']['output']>;
  postCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  streetAddress: Maybe<Scalars['String']['output']>;
};

export type CompanyReporting = {
  __typename?: 'CompanyReporting';
  url: Maybe<Scalars['Url']['output']>;
};

export enum CompanySwitchKnownDetail {
  NextCompanyKnown = 'NEXT_COMPANY_KNOWN',
  NothingKnown = 'NOTHING_KNOWN',
  OnlyPersonalKnown = 'ONLY_PERSONAL_KNOWN',
  WorkEmailKnown = 'WORK_EMAIL_KNOWN'
}

export enum CompanyUsageModeInput {
  Personal = 'PERSONAL',
  Project = 'PROJECT',
  Shared = 'SHARED'
}

export type ConfirmationPageSettings = {
  __typename?: 'ConfirmationPageSettings';
  /** The url to redirect to once form submission has succeede */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** The header text to display on the thank you page */
  thankYouHeader: Maybe<Scalars['String']['output']>;
  /** The message text to display on the thank you page */
  thankYouMessage: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  changedJob: Scalars['Boolean']['output'];
  company: Company;
  contactCompanySwitch: Maybe<ContactCompanySwitch>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  emailAddresses: Array<Scalars['ContactEmailScalar']['output']>;
  id: Scalars['ID']['output'];
  inMyContacts: Maybe<Scalars['Boolean']['output']>;
  info: ContactInfo;
  interactionsBounce: Maybe<BounceCount>;
  interactionsIsEngaged: Scalars['Boolean']['output'];
  interactionsLast: LastAts;
  interactionsTotal: Totals;
  /** @deprecated Use interactionsIsEngaged instead */
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isEmployee: Scalars['Boolean']['output'];
  isKeyContact: Scalars['Boolean']['output'];
  isPersonal: Scalars['Boolean']['output'];
  marketingListConsent: ContactConsent;
  nextCompanyContact: Maybe<PersonCompanyContact>;
  officeLocation: Maybe<CompanyOfficeLocation>;
  primaryEmail: Maybe<Scalars['ContactEmailScalar']['output']>;
  unarchiveOnNextInteraction: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  whoKnows: Array<WhoKnows>;
};


export type ContactWhoKnowsArgs = {
  connectionCategory?: WhoKnowsCategory;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactCard = {
  __typename?: 'ContactCard';
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Deprecated: Use company_card instead. */
  company: CompanyGrid;
  companyCard: CompanyCard;
  companyDetail: CompanyDetail;
  companyExternalIdentifier: Maybe<ExternalIdentifier>;
  companyKeyContactSince: Maybe<Scalars['ISO8601DateTime']['output']>;
  companySwitchKnownDetail: Maybe<CompanySwitchKnownDetail>;
  contactId: Scalars['ID']['output'];
  contactLocation: Maybe<Location>;
  displayName: Scalars['String']['output'];
  educations: Maybe<Scalars['GridStringArrayScalar']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isBounced: Maybe<Scalars['Boolean']['output']>;
  isInteractionsEngaged: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  linkedinUrl: Maybe<Scalars['Url']['output']>;
  phoneNumbers: Maybe<Scalars['GridStringArrayScalar']['output']>;
  primaryEmail: Maybe<Scalars['ContactEmailScalar']['output']>;
  tags: Maybe<Scalars['GridStringArrayScalar']['output']>;
  twitterUrl: Maybe<Scalars['String']['output']>;
};

export type ContactCompanySwitch = {
  __typename?: 'ContactCompanySwitch';
  /** @deprecated Never implemented */
  company: Maybe<Company>;
  creator: User;
  id: Scalars['ID']['output'];
  knownDetail: Maybe<CompanySwitchKnownDetail>;
};

export type ContactConsent = {
  __typename?: 'ContactConsent';
  autoChangedReason: Maybe<Scalars['String']['output']>;
  howWasConsentGiven: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  status: ContactConsentStatus;
  whenWasConsentGiven: Maybe<Scalars['ISO8601Date']['output']>;
};

export enum ContactConsentStatus {
  ConsentGiven = 'CONSENT_GIVEN',
  ConsentNotGiven = 'CONSENT_NOT_GIVEN',
  LegitimateInterest = 'LEGITIMATE_INTEREST',
  UserUnsubscribed = 'USER_UNSUBSCRIBED'
}

export type ContactForCustomField = {
  __typename?: 'ContactForCustomField';
  company: Company;
  id: Scalars['ID']['output'];
  info: ContactInfoForCustomField;
  interactionsBounce: Maybe<BounceCount>;
  interactionsIsEngaged: Scalars['Boolean']['output'];
  /** @deprecated Use interactionsIsEngaged instead */
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isKeyContact: Scalars['Boolean']['output'];
  primaryEmail: Maybe<Scalars['ContactEmailScalar']['output']>;
};

export type ContactGrid = {
  __typename?: 'ContactGrid';
  city: Maybe<Scalars['String']['output']>;
  company: CompanyGrid;
  country: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isKeyContact: Scalars['Boolean']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  primaryEmail: Scalars['ContactEmailScalar']['output'];
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  customFields: Maybe<Array<CustomField>>;
  department: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  educations: Array<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  linkedinUrl: Maybe<Scalars['Url']['output']>;
  location: Maybe<Location>;
  office: Maybe<Scalars['String']['output']>;
  phoneNumbers: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  twitterUrl: Maybe<Scalars['String']['output']>;
};


export type ContactInfoImageUrlArgs = {
  preferIdenticonFallback?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactInfoForCustomField = {
  __typename?: 'ContactInfoForCustomField';
  firstName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  imageUrl: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
};

export type ContactJobTitle = {
  __typename?: 'ContactJobTitle';
  endDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startDate: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Country information */
export type Country = {
  __typename?: 'Country';
  code: CountryCode;
  emojiFlag: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Alpha 2 code representing a country */
export enum CountryCode {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo, The Democratic Republic of the */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cabo Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czechia */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands (Malvinas) */
  Fk = 'FK',
  /** Micronesia, Federated States of */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Lao People's Democratic Republic */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** North Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine, State of */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russian Federation */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syrian Arab Republic */
  Sy = 'SY',
  /** Eswatini */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Türkiye */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Holy See (Vatican City State) */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** Virgin Islands, British */
  Vg = 'VG',
  /** Virgin Islands, U.S. */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

/** Currency information */
export type Currency = {
  __typename?: 'Currency';
  decimalMark: Scalars['String']['output'];
  exponent: Scalars['Int']['output'];
  isoCode: CurrencyCode;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  symbolFirst: Scalars['Boolean']['output'];
  thousandsSeparator: Scalars['String']['output'];
};

/** Currency iso code */
export enum CurrencyCode {
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Gulden */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bitcoin Cash */
  Bch = 'BCH',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudian Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bitcoin */
  Btc = 'BTC',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Botswana Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belarusian Ruble */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** Swiss Franc */
  Chf = 'CHF',
  /** Unidad de Fomento */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Renminbi Yuan Offshore */
  Cnh = 'CNH',
  /** Chinese Renminbi Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Czech Koruna */
  Czk = 'CZK',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Pound */
  Fkp = 'FKP',
  /** British Pound */
  Gbp = 'GBP',
  /** British Penny */
  Gbx = 'GBX',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Guernsey Pound */
  Ggp = 'GGP',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Guyanese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Israeli New Sheqel */
  Ils = 'ILS',
  /** Isle of Man Pound */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Jersey Pound */
  Jep = 'JEP',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgyzstani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Lao Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tögrög */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya */
  Mro = 'MRO',
  /** Mauritanian Ouguiya */
  Mru = 'MRU',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Złoty */
  Pln = 'PLN',
  /** Paraguayan Guaraní */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Saint Helenian Pound */
  Shp = 'SHP',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** New Leone */
  Sle = 'SLE',
  /** Sierra Leonean Leone */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé and Príncipe Dobra */
  Std = 'STD',
  /** São Tomé and Príncipe Second Dobra */
  Stn = 'STN',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat */
  Tmm = 'TMM',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd = 'TTD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** United States Dollar */
  Usd = 'USD',
  /** USD Coin */
  Usdc = 'USDC',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uzbekistan Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar */
  Vef = 'VEF',
  /** Venezuelan Bolívar Soberano */
  Ves = 'VES',
  /** Vietnamese Đồng */
  Vnd = 'VND',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African Cfa Franc */
  Xaf = 'XAF',
  /** Silver (Troy Ounce) */
  Xag = 'XAG',
  /** Gold (Troy Ounce) */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account 9 */
  Xbc = 'XBC',
  /** European Unit of Account 17 */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** UIC Franc */
  Xfu = 'XFU',
  /** West African Cfa Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** Cfp Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** Codes specifically reserved for testing purposes */
  Xts = 'XTS',
  /** Yemeni Rial */
  Yer = 'YER',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha */
  Zmk = 'ZMK',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zimbabwean Dollar */
  Zwd = 'ZWD',
  /** Zimbabwean Dollar */
  Zwl = 'ZWL',
  /** Zimbabwean Dollar */
  Zwn = 'ZWN',
  /** Zimbabwean Dollar */
  Zwr = 'ZWR'
}

export type CustomCurrencyFieldGrid = {
  __typename?: 'CustomCurrencyFieldGrid';
  amount: Maybe<Money>;
};

export type CustomDatetimeFieldGrid = {
  __typename?: 'CustomDatetimeFieldGrid';
  date: Maybe<Scalars['ISO8601Date']['output']>;
};

export type CustomEmployeeFieldGrid = {
  __typename?: 'CustomEmployeeFieldGrid';
  employee: Maybe<EmployeeGrid>;
};

/** Company goal custom fields */
export type CustomField = {
  __typename?: 'CustomField';
  currency: Maybe<Currency>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  schemaId: Scalars['ID']['output'];
  stringValue: Scalars['String']['output'];
  value: Maybe<CustomFieldValue>;
  valueTypeEnum: Maybe<CustomFieldSchemaValue>;
};

export type CustomFieldCompany = {
  __typename?: 'CustomFieldCompany';
  companies: Maybe<Array<CompanyForCustomField>>;
};

export type CustomFieldContact = {
  __typename?: 'CustomFieldContact';
  contacts: Maybe<Array<ContactForCustomField>>;
};

export type CustomFieldDate = {
  __typename?: 'CustomFieldDate';
  dateValue: Maybe<Scalars['ISO8601Date']['output']>;
};

export type CustomFieldEmployee = {
  __typename?: 'CustomFieldEmployee';
  employee: Maybe<EmployeeForCustomField>;
};

export type CustomFieldFullDateTime = {
  __typename?: 'CustomFieldFullDateTime';
  dateTime: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Opportunity custom fields */
export type CustomFieldGrid = {
  __typename?: 'CustomFieldGrid';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  schemaId: Scalars['ID']['output'];
  schemaValueType: CustomFieldSchemaValue;
  stringValue: Maybe<Scalars['String']['output']>;
  value: Maybe<CustomFieldGridValueUnion>;
};

export type CustomFieldGridValueUnion = CustomCurrencyFieldGrid | CustomDatetimeFieldGrid | CustomEmployeeFieldGrid | CustomFullDateTimeFieldGrid | CustomMultiCompanyFieldGrid | CustomMultiContactFieldGrid | CustomMultiCountryFieldGrid | CustomMultiEmployeeFieldGrid | CustomMultiOptionalValueFieldGrid | CustomNewlyDefinedFieldGrid | CustomNumberFieldGrid | CustomOptionalValueFieldGrid | CustomRichTextFieldGrid | CustomTextFieldGrid;

export type CustomFieldMoney = {
  __typename?: 'CustomFieldMoney';
  moneyValue: Maybe<Money>;
};

export type CustomFieldMulti = {
  __typename?: 'CustomFieldMulti';
  multiOption: Maybe<Array<Option>>;
};

export type CustomFieldMultiCountry = {
  __typename?: 'CustomFieldMultiCountry';
  countries: Maybe<Array<Country>>;
};

export type CustomFieldMultiEmployee = {
  __typename?: 'CustomFieldMultiEmployee';
  employees: Maybe<Array<EmployeeForCustomField>>;
};

export type CustomFieldNumber = {
  __typename?: 'CustomFieldNumber';
  numberValue: Maybe<Scalars['BigInt']['output']>;
};

export type CustomFieldOptional = {
  __typename?: 'CustomFieldOptional';
  option: Maybe<Option>;
};

export type CustomFieldRichText = {
  __typename?: 'CustomFieldRichText';
  richContent: RichContent;
};

export type CustomFieldSchema = {
  __typename?: 'CustomFieldSchema';
  currency: Maybe<Currency>;
  hideFromForm: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optionChoices: Maybe<Array<OptionChoice>>;
  position: Scalars['Int']['output'];
  schemaId: Scalars['String']['output'];
  searchable: Maybe<Scalars['Boolean']['output']>;
  usage: CustomFieldSchemaUsage;
  valueTypeEnum: CustomFieldSchemaValue;
};

export enum CustomFieldSchemaUsage {
  Default = 'DEFAULT',
  Preference = 'PREFERENCE'
}

export enum CustomFieldSchemaValue {
  Currency = 'CURRENCY',
  Datetime = 'DATETIME',
  Employee = 'EMPLOYEE',
  FullDateTime = 'FULL_DATE_TIME',
  MultiCompany = 'MULTI_COMPANY',
  MultiContact = 'MULTI_CONTACT',
  MultiCountry = 'MULTI_COUNTRY',
  MultiEmployee = 'MULTI_EMPLOYEE',
  MultiOptionalValue = 'MULTI_OPTIONAL_VALUE',
  Number = 'NUMBER',
  OptionalValue = 'OPTIONAL_VALUE',
  RichText = 'RICH_TEXT',
  Text = 'TEXT'
}

export type CustomFieldString = {
  __typename?: 'CustomFieldString';
  stringValue: Maybe<Scalars['String']['output']>;
};

export type CustomFieldTimeRange = {
  __typename?: 'CustomFieldTimeRange';
  timeRange: Maybe<TimeRange>;
};

/** Custom Field Value */
export type CustomFieldValue = CustomFieldCompany | CustomFieldContact | CustomFieldDate | CustomFieldEmployee | CustomFieldFullDateTime | CustomFieldMoney | CustomFieldMulti | CustomFieldMultiCountry | CustomFieldMultiEmployee | CustomFieldNumber | CustomFieldOptional | CustomFieldRichText | CustomFieldString | CustomFieldTimeRange;

export type CustomFullDateTimeFieldGrid = {
  __typename?: 'CustomFullDateTimeFieldGrid';
  dateTime: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type CustomMultiCompanyFieldGrid = {
  __typename?: 'CustomMultiCompanyFieldGrid';
  companies: Array<CompanyGrid>;
  companyCards: Array<CompanyCard>;
  companyDetails: Array<CompanyDetail>;
};

export type CustomMultiContactFieldGrid = {
  __typename?: 'CustomMultiContactFieldGrid';
  contactCards: Array<ContactCard>;
  contacts: Array<ContactGrid>;
};

export type CustomMultiCountryFieldGrid = {
  __typename?: 'CustomMultiCountryFieldGrid';
  countries: Array<Country>;
};

export type CustomMultiEmployeeFieldGrid = {
  __typename?: 'CustomMultiEmployeeFieldGrid';
  employees: Array<EmployeeGrid>;
};

export type CustomMultiOptionalValueFieldGrid = {
  __typename?: 'CustomMultiOptionalValueFieldGrid';
  selected: Array<Option>;
};

export type CustomNewlyDefinedFieldGrid = {
  __typename?: 'CustomNewlyDefinedFieldGrid';
  customableId: Maybe<Scalars['String']['output']>;
};

export type CustomNumberFieldGrid = {
  __typename?: 'CustomNumberFieldGrid';
  /** @deprecated Use `numberValue` instead */
  number: Maybe<Scalars['Int']['output']>;
  numberValue: Maybe<Scalars['BigInt']['output']>;
};

export type CustomOptionalValueFieldGrid = {
  __typename?: 'CustomOptionalValueFieldGrid';
  selected: Maybe<Option>;
};

export type CustomRichTextFieldGrid = {
  __typename?: 'CustomRichTextFieldGrid';
  html: Scalars['String']['output'];
  plainText: Scalars['String']['output'];
  trixHtml: Scalars['String']['output'];
};

export type CustomTextFieldGrid = {
  __typename?: 'CustomTextFieldGrid';
  text: Maybe<Scalars['String']['output']>;
};

export type Department = {
  __typename?: 'Department';
  employees: Array<Employee>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type DepartmentEmployeesArgs = {
  limit?: Scalars['Int']['input'];
};

export enum DisplayAs {
  Checkbox = 'CHECKBOX',
  ConsentStatus = 'CONSENT_STATUS',
  Country = 'COUNTRY',
  Currency = 'CURRENCY',
  Datetime = 'DATETIME',
  Employee = 'EMPLOYEE',
  FullDateTime = 'FULL_DATE_TIME',
  MultiCompany = 'MULTI_COMPANY',
  MultiContact = 'MULTI_CONTACT',
  MultiCountry = 'MULTI_COUNTRY',
  MultiEmployee = 'MULTI_EMPLOYEE',
  MultiOptionalValue = 'MULTI_OPTIONAL_VALUE',
  Number = 'NUMBER',
  OptionalValue = 'OPTIONAL_VALUE',
  RadioButton = 'RADIO_BUTTON',
  RichText = 'RICH_TEXT',
  Tags = 'TAGS',
  Text = 'TEXT'
}

/** An educational institution attended by a person */
export type Education = {
  __typename?: 'Education';
  /** End date of the education */
  endDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unique identifier for the education record */
  id: Scalars['ID']['output'];
  /** Name of the educational institution */
  institution: Maybe<Scalars['String']['output']>;
  /** The person associated with this education record */
  person: Person;
  /** Start date of the education */
  startDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Degree or qualification obtained */
  value: Maybe<Scalars['String']['output']>;
};

export type EmbedUrl = {
  __typename?: 'EmbedUrl';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url: Scalars['String']['output'];
};

export type Employee = {
  __typename?: 'Employee';
  contact: Contact;
  department: Maybe<Department>;
  email: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  info: ContactInfo;
  office: Maybe<Office>;
};

export type EmployeeForCustomField = {
  __typename?: 'EmployeeForCustomField';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  info: ContactInfoForCustomField;
};

export type EmployeeGrid = {
  __typename?: 'EmployeeGrid';
  departmentName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  officeName: Maybe<Scalars['String']['output']>;
};

export enum ExecutionStatus {
  AwaitingStart = 'AWAITING_START',
  Complete = 'COMPLETE',
  CopyingContacts = 'COPYING_CONTACTS',
  CopyingContactsComplete = 'COPYING_CONTACTS_COMPLETE',
  ValidationInProgress = 'VALIDATION_IN_PROGRESS'
}

export type ExternalIdentifier = {
  __typename?: 'ExternalIdentifier';
  client: Scalars['String']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type File = {
  __typename?: 'File';
  /** @deprecated use url instead */
  content: Maybe<Scalars['String']['output']>;
  contentType: Maybe<Scalars['String']['output']>;
  fileUuid: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  url: Scalars['Url']['output'];
};

export type Folder = {
  __typename?: 'Folder';
  id: Scalars['ID']['output'];
  isRoot: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent: Maybe<Folder>;
  projectsCount: Scalars['Int']['output'];
};

/** Objects which may be a Form Element */
export type FormElement = InputElement | TextElement;

export type FormExpirySettings = {
  __typename?: 'FormExpirySettings';
  date: Maybe<Scalars['ISO8601DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
  formId: Scalars['ID']['output'];
  /** Page description with HTML content */
  pageDescription: Maybe<PageDescription>;
  pageHeader: Maybe<Scalars['String']['output']>;
};

export type FormPrefillData = {
  __typename?: 'FormPrefillData';
  entries: Array<FormPrefillEntry>;
};

export type FormPrefillEntry = {
  __typename?: 'FormPrefillEntry';
  formElementId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type FormTheme = {
  __typename?: 'FormTheme';
  coverImage: Maybe<File>;
  id: Scalars['ID']['output'];
};

export enum FormVersionEnum {
  DraftVersion = 'DRAFT_VERSION',
  PublishedVersion = 'PUBLISHED_VERSION'
}

/** Waitlist settings for a form */
export type FormWaitlistSettings = {
  __typename?: 'FormWaitlistSettings';
  /** The condition for triggering the waitlist */
  condition: Maybe<WaitlistCondition>;
  /** Indicates if the waitlist is enabled */
  enabled: Scalars['Boolean']['output'];
  /** The ID of the form this waitlist settings belong to */
  formId: Scalars['ID']['output'];
  /** Indicates if the waitlist is redirect required */
  redirectRequired: Scalars['Boolean']['output'];
  /** The URL to redirect to when the waitlist is triggered */
  redirectUrl: Maybe<Scalars['String']['output']>;
};

export type GenericList = {
  __typename?: 'GenericList';
  createdAt: Scalars['ISO8601DateTime']['output'];
  customFieldSchemas: Array<CustomFieldSchema>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  items: Array<GenericListItem>;
  reminderSettings: Array<ReminderSetting>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GenericListItem = {
  __typename?: 'GenericListItem';
  completedTasksCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use gridCustomFields instead */
  customFields: Array<CustomField>;
  genericList: GenericList;
  gridCustomFields: Array<CustomFieldGrid>;
  id: Scalars['ID']['output'];
  listReminders: Array<Reminder>;
  tasksCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Hierarchy = {
  __typename?: 'Hierarchy';
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  partOfHierarchy: Scalars['Boolean']['output'];
};

export type InputElement = {
  __typename?: 'InputElement';
  customField: Maybe<CustomFieldSchema>;
  customFieldSchemaId: Maybe<Scalars['ID']['output']>;
  defaultValue: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  displayAs: Maybe<DisplayAs>;
  field: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  /** ID of the element (can be null when invalid) */
  id: Maybe<Scalars['ID']['output']>;
  label: Maybe<Scalars['String']['output']>;
  placeholder: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type InsightStat = {
  __typename?: 'InsightStat';
  id: Scalars['ID']['output'];
  lastBdInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastLeadInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastMarketingInteractionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  previousTotalEmails: Scalars['Int']['output'];
  previousTotalInteractions: Scalars['Int']['output'];
  previousTotalMeetings: Scalars['Int']['output'];
  totalEmails: Scalars['Int']['output'];
  totalEmailsIncrease: Scalars['Int']['output'];
  totalInteractionIncrease: Scalars['Int']['output'];
  totalInteractions: Scalars['Int']['output'];
  totalMeetings: Scalars['Int']['output'];
  totalMeetingsIncrease: Scalars['Int']['output'];
};

export type InteractionMonthlyStat = {
  __typename?: 'InteractionMonthlyStat';
  id: Maybe<Scalars['ID']['output']>;
  interactionCount: Maybe<Scalars['Int']['output']>;
  meetingCount: Maybe<Scalars['Int']['output']>;
  monthAsDate: Scalars['ISO8601Date']['output'];
  receivedEmailCount: Maybe<Scalars['Int']['output']>;
  sentEmailCount: Maybe<Scalars['Int']['output']>;
};

export type InternalIndustry = {
  __typename?: 'InternalIndustry';
  companyInfoInternalIndustryCount: Scalars['Int']['output'];
  id: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export type KeyActivityList = {
  __typename?: 'KeyActivityList';
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  includesKeyActivity: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  project: Maybe<Project>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type KeyActivityListIncludesKeyActivityArgs = {
  keyActivityUid?: InputMaybe<Scalars['ID']['input']>;
};

export type LastAts = {
  __typename?: 'LastAts';
  emailAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interactionAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  meetingAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  receivedEmailAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  sentEmailAt: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type LastYearCompanyDepartmentStat = {
  __typename?: 'LastYearCompanyDepartmentStat';
  company: Company;
  department: Department;
  id: Maybe<Scalars['ID']['output']>;
  interactionCount: Maybe<Scalars['Int']['output']>;
  meetingCount: Maybe<Scalars['Int']['output']>;
  monthlyStats: Array<InteractionMonthlyStat>;
  receivedEmailCount: Maybe<Scalars['Int']['output']>;
  sentEmailCount: Maybe<Scalars['Int']['output']>;
};

export type List = {
  __typename?: 'List';
  allowDuplicates: Scalars['Boolean']['output'];
  category: Maybe<ListCategory>;
  clean: Maybe<Clean>;
  contactsCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: Maybe<User>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  memberCustomFields: Maybe<Array<CustomFieldSchema>>;
  name: Scalars['String']['output'];
  project: Maybe<Project>;
  reminderSettings: Array<ReminderSetting>;
  renderMode: RenderMode;
  tabUid: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usageMode: UsageMode;
};

export enum ListCategory {
  ClientAlert = 'CLIENT_ALERT',
  CountryGroup = 'COUNTRY_GROUP',
  EventInvite = 'EVENT_INVITE',
  GeneralMarketing = 'GENERAL_MARKETING',
  Newsletter = 'NEWSLETTER',
  OfficeLists = 'OFFICE_LISTS',
  Other = 'OTHER',
  PracticeArea = 'PRACTICE_AREA',
  SectorOrIndustry = 'SECTOR_OR_INDUSTRY',
  Subscribers = 'SUBSCRIBERS',
  WebinarInvite = 'WEBINAR_INVITE'
}

export type ListView = {
  __typename?: 'ListView';
  /** AGgrid Column state configuration */
  columnStateConfiguration: Maybe<UiConfiguration>;
  /** Aggrid Filter model configuration */
  filterModelConfiguration: Maybe<UiConfiguration>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  renderMode: ListViewRenderMode;
  /** Schema uid of either single select, employee or datetime custom field */
  schemaUid: Maybe<Scalars['ID']['output']>;
  viewType: ListViewType;
};

export enum ListViewRenderMode {
  Default = 'DEFAULT',
  Large = 'LARGE'
}

export enum ListViewType {
  Board = 'BOARD',
  Calendar = 'CALENDAR',
  List = 'LIST',
  Timeline = 'TIMELINE'
}

export type Location = {
  __typename?: 'Location';
  brief: Scalars['String']['output'];
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Country>;
  id: Scalars['ID']['output'];
  postCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  streetAddress: Maybe<Scalars['String']['output']>;
};

export type Money = {
  __typename?: 'Money';
  cents: Scalars['BigInt']['output'];
  currency: Currency;
  format: Scalars['String']['output'];
};

export type Objective = {
  __typename?: 'Objective';
  appendValueType: Scalars['Boolean']['output'];
  archive: Scalars['Boolean']['output'];
  createdBy: User;
  currentProgress: Progress;
  description: Maybe<RichContent>;
  id: Scalars['ID']['output'];
  initialValue: Maybe<Scalars['Int']['output']>;
  objectiveProgresses: Array<Progress>;
  owners: Array<Employee>;
  projects: Array<Project>;
  targetDate: Scalars['ISO8601Date']['output'];
  targetValue: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  valueType: Scalars['String']['output'];
};

export type Office = {
  __typename?: 'Office';
  employees: Array<Employee>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type OfficeEmployeesArgs = {
  limit?: Scalars['Int']['input'];
};

export enum OperationTypeEnum {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export type OpportunityStat = {
  __typename?: 'OpportunityStat';
  totalOpenCount: Scalars['Int']['output'];
  totalPercentageWon: Scalars['Float']['output'];
  totalProposalFee: Scalars['Float']['output'];
  totalWonCount: Scalars['Int']['output'];
  totalWonProposalFee: Maybe<Scalars['Float']['output']>;
};

export type Option = {
  __typename?: 'Option';
  colour: AccountColour;
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type OptionChoice = {
  __typename?: 'OptionChoice';
  colour: AccountColour;
  id: Scalars['String']['output'];
  optionChoiceId: Scalars['String']['output'];
  orderRank: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

/** Page description for form expiry with HTML content */
export type PageDescription = {
  __typename?: 'PageDescription';
  /** Raw HTML content for editor */
  htmlForEditor: Maybe<Scalars['String']['output']>;
  /** Sanitized HTML content for safe display */
  renderSafeHtml: Maybe<Scalars['String']['output']>;
};

/** Company list, contact list, or saved view fields value */
export type PageResult = BlockPageList | Campaign | CompanyListItem | EmbedUrl | GenericList | KeyActivityList | List | SaveView;

export type Person = {
  __typename?: 'Person';
  activeContacts: Array<Contact>;
  careerCompanies: Array<CareerCompany>;
  /** @deprecated Use careerCompanies instead */
  companyContacts: Array<PersonCompanyContact>;
  contacts: Array<Contact>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  educations: Array<Education>;
  externalImageUrl: Maybe<Scalars['Url']['output']>;
  firstName: Scalars['String']['output'];
  gender: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  linkedinUrl: Maybe<Scalars['Url']['output']>;
  location: Maybe<Location>;
  phoneNumbers: Array<PhoneNumber>;
  skills: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  twitterUrl: Maybe<Scalars['Url']['output']>;
};

export type PersonCompanyContact = {
  __typename?: 'PersonCompanyContact';
  company: Maybe<Company>;
  companyDisplayName: Scalars['String']['output'];
  companyId: Maybe<Scalars['ID']['output']>;
  companyLinkedinUrl: Maybe<Scalars['Url']['output']>;
  companyName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use person { contacts } instead */
  contact: Maybe<Contact>;
  contactId: Maybe<Scalars['ID']['output']>;
  currentStartDate: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  jobTitle: Maybe<Scalars['String']['output']>;
  jobTitles: Array<ContactJobTitle>;
  person: Person;
};

/** A phone number associated with a person */
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  /** Unique identifier for the phone number */
  id: Scalars['ID']['output'];
  /** The person associated with this phone number */
  person: Person;
  /** Type of phone number (e.g., mobile, work) */
  phoneType: Maybe<Scalars['String']['output']>;
  /** The phone number value */
  value: Scalars['String']['output'];
};

export type Progress = {
  __typename?: 'Progress';
  checkinDate: Scalars['ISO8601Date']['output'];
  comment: Maybe<RichContent>;
  createdBy: User;
  id: Scalars['ID']['output'];
  measureValue: Scalars['Int']['output'];
  progressStatus: ProgressStatus;
};

export enum ProgressStatus {
  Lagging = 'LAGGING',
  Leading = 'LEADING',
  OnTrack = 'ON_TRACK'
}

export type Project = {
  __typename?: 'Project';
  colorCode: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Maybe<Employee>;
  description: Maybe<RichContent>;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  documents: Array<ProjectDocument>;
  firmWide: Scalars['Boolean']['output'];
  folder: Folder;
  iconCode: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nexlApps: Scalars['Boolean']['output'];
  objectives: Array<Objective>;
  opportunityCustomFieldSchemas: Array<CustomFieldSchema>;
  overviewTab: Maybe<ProjectOverviewTab>;
  readOnly: Scalars['Boolean']['output'];
  tabGroupName: Scalars['String']['output'];
  tabs: Array<TabResult>;
  teamMembersCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProjectDocument = {
  __typename?: 'ProjectDocument';
  file: Maybe<File>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['Url']['output']>;
};

export type ProjectOverviewTab = {
  __typename?: 'ProjectOverviewTab';
  id: Scalars['ID']['output'];
};

export type PublicCampaign = {
  __typename?: 'PublicCampaign';
  templateHtml: Maybe<Scalars['String']['output']>;
};

export type PublicForm = {
  __typename?: 'PublicForm';
  confirmationPageSettings: Maybe<ConfirmationPageSettings>;
  /** The default footer in HTML, to be displayed below the form. */
  defaultFooter: Maybe<Scalars['String']['output']>;
  /** Description of the form */
  description: Maybe<Scalars['String']['output']>;
  disableRecaptcha: Scalars['Boolean']['output'];
  /** The elements belonging to the form */
  elements: Array<FormElement>;
  /** Whether the form is expired */
  expired: Scalars['Boolean']['output'];
  expirySettings: Maybe<FormExpirySettings>;
  /** ID of the form */
  id: Scalars['ID']['output'];
  theme: FormTheme;
  /** Title of the form */
  title: Scalars['String']['output'];
  waitlistSettings: Maybe<FormWaitlistSettings>;
  /** The workflows belonging to the form */
  workflows: Maybe<Array<Workflow>>;
};

/** Form Element Inputs */
export type PublicFormElementInput = {
  elementId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum PublicFormVersion {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Reminder = {
  __typename?: 'Reminder';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  emailSentDate: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  reminderSetting: ReminderSetting;
  reminderSettingId: Scalars['ID']['output'];
};

export type ReminderSetting = {
  __typename?: 'ReminderSetting';
  dateProperty: Scalars['String']['output'];
  emailSubject: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owners: Array<ReminderSettingOwner>;
  reminderDays: Scalars['Int']['output'];
  timePreposition: ReminderSettingTimePreposition;
};

export type ReminderSettingOwner = {
  __typename?: 'ReminderSettingOwner';
  employee: Employee;
  id: Scalars['ID']['output'];
};

export enum ReminderSettingTimePreposition {
  After = 'AFTER',
  Before = 'BEFORE'
}

export enum RenderMode {
  ClientSide = 'CLIENT_SIDE',
  ServerSide = 'SERVER_SIDE'
}

export type RichContent = {
  __typename?: 'RichContent';
  html: Scalars['String']['output'];
  plainText: Scalars['String']['output'];
  trixHtml: Scalars['String']['output'];
};

export enum RoleCode {
  Admin = 'ADMIN',
  IndividualLawyer = 'INDIVIDUAL_LAWYER',
  Manager = 'MANAGER',
  Partner = 'PARTNER',
  RestrictedLawyer = 'RESTRICTED_LAWYER',
  Support = 'SUPPORT'
}

export type SaveView = {
  __typename?: 'SaveView';
  filter: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
};

export type Sender = {
  __typename?: 'Sender';
  /** @deprecated No longer used. */
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  replyTo: Scalars['String']['output'];
};

export enum SourceTypeEnum {
  /** Rollup field is based on company lists */
  CompanyList = 'COMPANY_LIST',
  /** Rollup field is based on contact lists */
  ContactList = 'CONTACT_LIST',
  /** Rollup field is based on generic lists */
  GenericList = 'GENERIC_LIST',
  /** Rollup field is based on key activity lists */
  KeyActivityList = 'KEY_ACTIVITY_LIST',
  /** Rollup field is based on opportunities */
  Opportunities = 'OPPORTUNITIES'
}

/** Autogenerated return type of SubmitFormMutation. */
export type SubmitFormMutationPayload = {
  __typename?: 'SubmitFormMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
  form: Maybe<PublicForm>;
};

export enum TabRenderMode {
  Advanced = 'ADVANCED',
  Standard = 'STANDARD'
}

/** Tab Field Value */
export type TabResult = {
  __typename?: 'TabResult';
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['String']['output'];
  isAppTab: Scalars['Boolean']['output'];
  isWorkspaceTab: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pageResult: PageResult;
  position: Scalars['Int']['output'];
  renderMode: TabRenderMode;
};

export type TableLikeRollupFieldType = {
  __typename?: 'TableLikeRollupFieldType';
  conditions: Maybe<ColumnsFilteringOutput>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentValue: Scalars['Float']['output'];
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operationType: OperationTypeEnum;
  ownedById: Scalars['ID']['output'];
  ownedByType: TableLikeRollupOwnedByTypeEnum;
  sourceListId: Maybe<Scalars['ID']['output']>;
  sourceListName: Maybe<Scalars['String']['output']>;
  sourceListType: Maybe<TableLikeRollupSourceListTypeEnum>;
  sourceType: SourceTypeEnum;
  targetColumnId: Maybe<Scalars['String']['output']>;
  targetColumnName: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Possible types for an owner of a rollup field */
export enum TableLikeRollupOwnedByTypeEnum {
  /** The rollup field is owned by a Project */
  Project = 'PROJECT'
}

/** Possible types for the source list of a rollup field */
export enum TableLikeRollupSourceListTypeEnum {
  /** The source for rollup is a Company List */
  CompanyList = 'COMPANY_LIST',
  /** The source for rollup is a Contact List */
  ContactList = 'CONTACT_LIST',
  /** The source for rollup is a Generic List */
  GenericList = 'GENERIC_LIST',
  /** The source for rollup is a Key Activity List */
  KeyActivityList = 'KEY_ACTIVITY_LIST',
  /** The source for rollup is a generic List */
  List = 'LIST'
}

export type TextElement = {
  __typename?: 'TextElement';
  /** ID of the element (can be null when invalid) */
  id: Maybe<Scalars['ID']['output']>;
  /** The text to be displayed in the text element on the form */
  value: Scalars['String']['output'];
};

/** Time Range information */
export type TimeRange = {
  __typename?: 'TimeRange';
  endTime: Scalars['ISO8601DateTime']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
};

export type Totals = {
  __typename?: 'Totals';
  emails: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interactions: Scalars['Int']['output'];
  meetings: Scalars['Int']['output'];
  receivedEmails: Scalars['Int']['output'];
  sentEmails: Scalars['Int']['output'];
};

export type UiConfiguration = {
  __typename?: 'UiConfiguration';
  configuration: Maybe<Scalars['String']['output']>;
  featureName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  version: Maybe<Scalars['String']['output']>;
};

export type UnauthenticatedMutation = {
  __typename?: 'UnauthenticatedMutation';
  emailMarketingUnsubscribeCampaignRecipient: Maybe<UnsubscribeCampaignRecipientMutationPayload>;
  /** Handle a form submission */
  submitForm: Maybe<SubmitFormMutationPayload>;
  /** Update the contents of block page */
  updateYjsBlockPageContent: Maybe<UpdateYjsBlockPageContentMutationPayload>;
};


export type UnauthenticatedMutationEmailMarketingUnsubscribeCampaignRecipientArgs = {
  emsUserToken: Scalars['String']['input'];
};


export type UnauthenticatedMutationSubmitFormArgs = {
  formId: Scalars['ID']['input'];
  inputs: Array<PublicFormElementInput>;
  recaptchaResponse: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<PublicFormVersion>;
};


export type UnauthenticatedMutationUpdateYjsBlockPageContentArgs = {
  apiKey: Scalars['String']['input'];
  contentInBinary: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};

export type UnauthenticatedQuery = {
  __typename?: 'UnauthenticatedQuery';
  emailMarketingCampaign: Maybe<PublicCampaign>;
  emailMarketingCampaignRecipientUnsubscribeData: Maybe<CampaignRecipientUnsubscribeData>;
  emailMarketingCampaignRecipientVariables: Maybe<CampaignRecipientVariables>;
  emailMarketingFormPrefillData: Maybe<FormPrefillData>;
  /** Returns wether the feature is enabled */
  featureEnabled: Scalars['Boolean']['output'];
  /** A public form representation */
  form: Maybe<PublicForm>;
  yjsBlockPage: Maybe<BlockPageContent>;
};


export type UnauthenticatedQueryEmailMarketingCampaignArgs = {
  uid: Scalars['ID']['input'];
};


export type UnauthenticatedQueryEmailMarketingCampaignRecipientUnsubscribeDataArgs = {
  emsUserToken: Scalars['String']['input'];
};


export type UnauthenticatedQueryEmailMarketingCampaignRecipientVariablesArgs = {
  emsUserToken: Scalars['String']['input'];
};


export type UnauthenticatedQueryEmailMarketingFormPrefillDataArgs = {
  emsUserToken: Scalars['String']['input'];
  uid: Scalars['ID']['input'];
};


export type UnauthenticatedQueryFeatureEnabledArgs = {
  name: Scalars['String']['input'];
};


export type UnauthenticatedQueryFormArgs = {
  uid: Scalars['ID']['input'];
  version?: FormVersionEnum;
};


export type UnauthenticatedQueryYjsBlockPageArgs = {
  apiKey: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['ID']['input'];
};

/** Autogenerated return type of UnsubscribeCampaignRecipientMutation. */
export type UnsubscribeCampaignRecipientMutationPayload = {
  __typename?: 'UnsubscribeCampaignRecipientMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of UpdateYjsBlockPageContentMutation. */
export type UpdateYjsBlockPageContentMutationPayload = {
  __typename?: 'UpdateYjsBlockPageContentMutationPayload';
  failReasons: Array<Scalars['String']['output']>;
};

export enum UsageMode {
  Marketing = 'MARKETING',
  Personal = 'PERSONAL',
  Project = 'PROJECT',
  Tab = 'TAB'
}

export type User = {
  __typename?: 'User';
  accessRole: Maybe<AccessRole>;
  archivedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  canArchiveContactsAndCompanies: Scalars['Boolean']['output'];
  canUpdateCompanyName: Scalars['Boolean']['output'];
  canViewActivityViewDetail: Scalars['Boolean']['output'];
  canViewEmbeddedReport: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  employee: Maybe<Employee>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLoginAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  profileImageUrl: Maybe<Scalars['String']['output']>;
  profileName: Scalars['String']['output'];
  role: RoleCode;
  userId: Scalars['ID']['output'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  /** @deprecated No longer available */
  canArchiveContactsAndCompanies: Scalars['String']['output'];
  /** @deprecated No longer available */
  canUpdateCompanyName: Scalars['String']['output'];
  /** @deprecated No longer available */
  canViewActivityViewDetail: Scalars['String']['output'];
  email: Scalars['String']['output'];
  employee: Maybe<Employee>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  profileImageUrl: Maybe<Scalars['String']['output']>;
  profileName: Scalars['String']['output'];
  role: RoleCode;
  userId: Scalars['ID']['output'];
};

export type UserSelection = {
  __typename?: 'UserSelection';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  profileImageUrl: Maybe<Scalars['String']['output']>;
  profileName: Scalars['String']['output'];
};

export type WaitlistCondition = {
  __typename?: 'WaitlistCondition';
  operator: Maybe<WaitlistConditionOperatorEnum>;
  /** The rollup field used for the waitlist condition */
  rollupField: Maybe<TableLikeRollupFieldType>;
  value: Maybe<Scalars['Int']['output']>;
};

/** Operators for waitlist condition comparison */
export enum WaitlistConditionOperatorEnum {
  /** Greater than or equal to the threshold value */
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL'
}

export type WhoKnows = {
  __typename?: 'WhoKnows';
  contact: Contact;
  contactCard: ContactCard;
  discardedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastInteraction: Scalars['ISO8601DateTime']['output'];
  numberOfInteractions: Scalars['Int']['output'];
  ownerContactCard: ContactCard;
};

export enum WhoKnowsCategory {
  Colleagues = 'COLLEAGUES',
  Employees = 'EMPLOYEES',
  ThirdParty = 'THIRD_PARTY'
}

export type Workflow = {
  __typename?: 'Workflow';
  /** The conditions for the workflow */
  conditions: Maybe<Array<WorkflowCondition>>;
  /** ID of the workflow */
  id: Scalars['ID']['output'];
  /** The recipient associated with this form (eg. contact list, or EMS campaign) */
  recipient: Maybe<WorkflowRecipient>;
  /** Deprecated: using UserSelectionType instead on subscribed_users_v2 */
  subscribedUsers: Maybe<Array<User>>;
  /** Users subscribed to this workflow */
  subscribedUsersV2: Maybe<Array<UserSelection>>;
  /** Deprecated: using UserSelectionType instead on subscribed_users_v2 */
  subscribers: Maybe<Array<UserInfo>>;
  /** The type of workflow to create */
  taskType: Maybe<WorkflowTask>;
};

export type WorkflowCondition = {
  __typename?: 'WorkflowCondition';
  /** The value of the condition */
  conditionValue: Scalars['String']['output'];
  /** The form field to which the condition is applied */
  customFieldSchema: CustomFieldSchema;
  /** ID of the workflow */
  id: Scalars['ID']['output'];
};

/** Contact list, or EMS campaign fields value */
export type WorkflowRecipient = Campaign | List;

export enum WorkflowTask {
  AddToList = 'ADD_TO_LIST',
  FollowUpCampaign = 'FOLLOW_UP_CAMPAIGN',
  SendNotification = 'SEND_NOTIFICATION'
}

export type CampaignEmailTemplateQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
  emsUserToken: Scalars['String']['input'];
}>;


export type CampaignEmailTemplateQuery = { __typename?: 'UnauthenticatedQuery', emailMarketingCampaign: { __typename?: 'PublicCampaign', templateHtml: string | null } | null, emailMarketingCampaignRecipientVariables: { __typename?: 'CampaignRecipientVariables', entries: Array<{ __typename?: 'CampaignRecipientVariable', key: string, value: string | null }> } | null };

export type EmailMarketingUnsubscribeCampaignRecipientMutationVariables = Exact<{
  emsUserToken: Scalars['String']['input'];
}>;


export type EmailMarketingUnsubscribeCampaignRecipientMutation = { __typename?: 'UnauthenticatedMutation', emailMarketingUnsubscribeCampaignRecipient: { __typename?: 'UnsubscribeCampaignRecipientMutationPayload', failReasons: Array<string> } | null };

export type EmailMarketingUnsubscribePageQueryVariables = Exact<{
  emsUserToken: Scalars['String']['input'];
}>;


export type EmailMarketingUnsubscribePageQuery = { __typename?: 'UnauthenticatedQuery', emailMarketingCampaignRecipientVariables: { __typename?: 'CampaignRecipientVariables', entries: Array<{ __typename?: 'CampaignRecipientVariable', key: string, value: string | null }> } | null, emailMarketingCampaignRecipientUnsubscribeData: { __typename?: 'CampaignRecipientUnsubscribeData', unsubscribeDomain: string | null } | null };

export type EmailMarketingFormPrefillDataQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
  emsUserToken: Scalars['String']['input'];
}>;


export type EmailMarketingFormPrefillDataQuery = { __typename?: 'UnauthenticatedQuery', emailMarketingFormPrefillData: { __typename?: 'FormPrefillData', entries: Array<{ __typename?: 'FormPrefillEntry', id: string, formElementId: string, value: string }> } | null };

export type FormPrefillEntryFragment = { __typename?: 'FormPrefillEntry', id: string, formElementId: string, value: string };

export type ConfirmationPageSettingsFragment = { __typename?: 'ConfirmationPageSettings', redirectUrl: string | null, thankYouMessage: string | null, thankYouHeader: string | null };

export type CustomFieldSchemaUnauthenticatedFragment = { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, hideFromForm: boolean, usage: CustomFieldSchemaUsage, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null };

export type ExpirySettingsPreviewFragment = { __typename?: 'FormExpirySettings', pageHeader: string | null, pageDescription: { __typename?: 'PageDescription', htmlForEditor: string | null, renderSafeHtml: string | null } | null };

export type FormQueryVariables = Exact<{
  uid: Scalars['ID']['input'];
  version: FormVersionEnum;
}>;


export type FormQuery = { __typename?: 'UnauthenticatedQuery', ff_release_13_form_footer_links_new_tab: boolean, form: { __typename?: 'PublicForm', id: string, title: string, description: string | null, expired: boolean, defaultFooter: string | null, disableRecaptcha: boolean, elements: Array<{ __typename?: 'InputElement', id: string | null, defaultValue: string | null, displayAs: DisplayAs | null, field: string, hidden: boolean, description: string | null, label: string | null, placeholder: string | null, required: boolean, customField: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, hideFromForm: boolean, usage: CustomFieldSchemaUsage, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null } | null } | { __typename?: 'TextElement', id: string | null, value: string }>, confirmationPageSettings: { __typename?: 'ConfirmationPageSettings', redirectUrl: string | null, thankYouMessage: string | null, thankYouHeader: string | null } | null, waitlistSettings: { __typename?: 'FormWaitlistSettings', redirectRequired: boolean, redirectUrl: string | null } | null, expirySettings: { __typename?: 'FormExpirySettings', pageHeader: string | null, pageDescription: { __typename?: 'PageDescription', htmlForEditor: string | null, renderSafeHtml: string | null } | null } | null, theme: { __typename?: 'FormTheme', id: string, coverImage: { __typename?: 'File', url: string } | null } } | null };

type FormElement_InputElement_Fragment = { __typename?: 'InputElement', id: string | null, defaultValue: string | null, displayAs: DisplayAs | null, field: string, hidden: boolean, description: string | null, label: string | null, placeholder: string | null, required: boolean, customField: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, hideFromForm: boolean, usage: CustomFieldSchemaUsage, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null } | null };

type FormElement_TextElement_Fragment = { __typename?: 'TextElement', id: string | null, value: string };

export type FormElementFragment = FormElement_InputElement_Fragment | FormElement_TextElement_Fragment;

export type FormInfoFragment = { __typename?: 'PublicForm', id: string, title: string, description: string | null, expired: boolean, defaultFooter: string | null, disableRecaptcha: boolean, elements: Array<{ __typename?: 'InputElement', id: string | null, defaultValue: string | null, displayAs: DisplayAs | null, field: string, hidden: boolean, description: string | null, label: string | null, placeholder: string | null, required: boolean, customField: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, hideFromForm: boolean, usage: CustomFieldSchemaUsage, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null } | null } | { __typename?: 'TextElement', id: string | null, value: string }>, confirmationPageSettings: { __typename?: 'ConfirmationPageSettings', redirectUrl: string | null, thankYouMessage: string | null, thankYouHeader: string | null } | null, waitlistSettings: { __typename?: 'FormWaitlistSettings', redirectRequired: boolean, redirectUrl: string | null } | null, expirySettings: { __typename?: 'FormExpirySettings', pageHeader: string | null, pageDescription: { __typename?: 'PageDescription', htmlForEditor: string | null, renderSafeHtml: string | null } | null } | null, theme: { __typename?: 'FormTheme', id: string, coverImage: { __typename?: 'File', url: string } | null } };

export type InputElementFragment = { __typename?: 'InputElement', id: string | null, defaultValue: string | null, displayAs: DisplayAs | null, field: string, hidden: boolean, description: string | null, label: string | null, placeholder: string | null, required: boolean, customField: { __typename?: 'CustomFieldSchema', id: string, schemaId: string, name: string, searchable: boolean | null, valueTypeEnum: CustomFieldSchemaValue, hideFromForm: boolean, usage: CustomFieldSchemaUsage, optionChoices: Array<{ __typename?: 'OptionChoice', id: string, optionChoiceId: string, value: string, colour: AccountColour, orderRank: number }> | null } | null };

export type SubmitFormMutationVariables = Exact<{
  formId: Scalars['ID']['input'];
  version?: InputMaybe<PublicFormVersion>;
  inputs: Array<PublicFormElementInput> | PublicFormElementInput;
  recaptchaResponse: Scalars['String']['input'];
}>;


export type SubmitFormMutation = { __typename?: 'UnauthenticatedMutation', submitForm: { __typename?: 'SubmitFormMutationPayload', failReasons: Array<string>, form: { __typename?: 'PublicForm', waitlistSettings: { __typename?: 'FormWaitlistSettings', redirectUrl: string | null, redirectRequired: boolean } | null } | null } | null };

export type TextElementFragment = { __typename?: 'TextElement', id: string | null, value: string };

export const FormPrefillEntryFragmentDoc = gql`
    fragment FormPrefillEntry on FormPrefillEntry {
  id
  formElementId
  value
}
    `;
export const CustomFieldSchemaUnauthenticatedFragmentDoc = gql`
    fragment CustomFieldSchemaUnauthenticated on CustomFieldSchema {
  id
  schemaId
  name
  searchable
  valueTypeEnum
  hideFromForm
  usage
  optionChoices {
    id
    optionChoiceId
    value
    colour
    orderRank
  }
}
    `;
export const InputElementFragmentDoc = gql`
    fragment InputElement on InputElement {
  id
  defaultValue
  displayAs
  field
  hidden
  description
  label
  placeholder
  required
  customField {
    ...CustomFieldSchemaUnauthenticated
  }
}
    ${CustomFieldSchemaUnauthenticatedFragmentDoc}`;
export const TextElementFragmentDoc = gql`
    fragment TextElement on TextElement {
  id
  value
}
    `;
export const FormElementFragmentDoc = gql`
    fragment FormElement on FormElement {
  ... on InputElement {
    ...InputElement
  }
  ... on TextElement {
    ...TextElement
  }
}
    ${InputElementFragmentDoc}
${TextElementFragmentDoc}`;
export const ConfirmationPageSettingsFragmentDoc = gql`
    fragment ConfirmationPageSettings on ConfirmationPageSettings {
  redirectUrl
  thankYouMessage
  thankYouHeader
}
    `;
export const ExpirySettingsPreviewFragmentDoc = gql`
    fragment ExpirySettingsPreview on FormExpirySettings {
  pageDescription {
    htmlForEditor
    renderSafeHtml
  }
  pageHeader
}
    `;
export const FormInfoFragmentDoc = gql`
    fragment FormInfo on PublicForm {
  id
  title
  description
  expired
  elements {
    ...FormElement
  }
  confirmationPageSettings {
    ...ConfirmationPageSettings
  }
  waitlistSettings {
    redirectRequired
    redirectUrl
  }
  expirySettings {
    ...ExpirySettingsPreview
  }
  defaultFooter
  disableRecaptcha
  theme {
    id
    coverImage {
      url
    }
  }
}
    ${FormElementFragmentDoc}
${ConfirmationPageSettingsFragmentDoc}
${ExpirySettingsPreviewFragmentDoc}`;
export const CampaignEmailTemplateDocument = gql`
    query CampaignEmailTemplate($uid: ID!, $emsUserToken: String!) {
  emailMarketingCampaign(uid: $uid) {
    templateHtml
  }
  emailMarketingCampaignRecipientVariables(emsUserToken: $emsUserToken) {
    entries {
      key
      value
    }
  }
}
    `;

/**
 * __useCampaignEmailTemplateQuery__
 *
 * To run a query within a React component, call `useCampaignEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignEmailTemplateQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      emsUserToken: // value for 'emsUserToken'
 *   },
 * });
 */
export function useCampaignEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<CampaignEmailTemplateQuery, CampaignEmailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignEmailTemplateQuery, CampaignEmailTemplateQueryVariables>(CampaignEmailTemplateDocument, options);
      }
export function useCampaignEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignEmailTemplateQuery, CampaignEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignEmailTemplateQuery, CampaignEmailTemplateQueryVariables>(CampaignEmailTemplateDocument, options);
        }
export type CampaignEmailTemplateQueryHookResult = ReturnType<typeof useCampaignEmailTemplateQuery>;
export type CampaignEmailTemplateLazyQueryHookResult = ReturnType<typeof useCampaignEmailTemplateLazyQuery>;
export type CampaignEmailTemplateQueryResult = Apollo.QueryResult<CampaignEmailTemplateQuery, CampaignEmailTemplateQueryVariables>;
export const EmailMarketingUnsubscribeCampaignRecipientDocument = gql`
    mutation EmailMarketingUnsubscribeCampaignRecipient($emsUserToken: String!) {
  emailMarketingUnsubscribeCampaignRecipient(emsUserToken: $emsUserToken) {
    failReasons
  }
}
    `;
export type EmailMarketingUnsubscribeCampaignRecipientMutationFn = Apollo.MutationFunction<EmailMarketingUnsubscribeCampaignRecipientMutation, EmailMarketingUnsubscribeCampaignRecipientMutationVariables>;

/**
 * __useEmailMarketingUnsubscribeCampaignRecipientMutation__
 *
 * To run a mutation, you first call `useEmailMarketingUnsubscribeCampaignRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingUnsubscribeCampaignRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailMarketingUnsubscribeCampaignRecipientMutation, { data, loading, error }] = useEmailMarketingUnsubscribeCampaignRecipientMutation({
 *   variables: {
 *      emsUserToken: // value for 'emsUserToken'
 *   },
 * });
 */
export function useEmailMarketingUnsubscribeCampaignRecipientMutation(baseOptions?: Apollo.MutationHookOptions<EmailMarketingUnsubscribeCampaignRecipientMutation, EmailMarketingUnsubscribeCampaignRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailMarketingUnsubscribeCampaignRecipientMutation, EmailMarketingUnsubscribeCampaignRecipientMutationVariables>(EmailMarketingUnsubscribeCampaignRecipientDocument, options);
      }
export type EmailMarketingUnsubscribeCampaignRecipientMutationHookResult = ReturnType<typeof useEmailMarketingUnsubscribeCampaignRecipientMutation>;
export type EmailMarketingUnsubscribeCampaignRecipientMutationResult = Apollo.MutationResult<EmailMarketingUnsubscribeCampaignRecipientMutation>;
export type EmailMarketingUnsubscribeCampaignRecipientMutationOptions = Apollo.BaseMutationOptions<EmailMarketingUnsubscribeCampaignRecipientMutation, EmailMarketingUnsubscribeCampaignRecipientMutationVariables>;
export const EmailMarketingUnsubscribePageDocument = gql`
    query EmailMarketingUnsubscribePage($emsUserToken: String!) {
  emailMarketingCampaignRecipientVariables(emsUserToken: $emsUserToken) {
    entries {
      key
      value
    }
  }
  emailMarketingCampaignRecipientUnsubscribeData(emsUserToken: $emsUserToken) {
    unsubscribeDomain
  }
}
    `;

/**
 * __useEmailMarketingUnsubscribePageQuery__
 *
 * To run a query within a React component, call `useEmailMarketingUnsubscribePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingUnsubscribePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingUnsubscribePageQuery({
 *   variables: {
 *      emsUserToken: // value for 'emsUserToken'
 *   },
 * });
 */
export function useEmailMarketingUnsubscribePageQuery(baseOptions: Apollo.QueryHookOptions<EmailMarketingUnsubscribePageQuery, EmailMarketingUnsubscribePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingUnsubscribePageQuery, EmailMarketingUnsubscribePageQueryVariables>(EmailMarketingUnsubscribePageDocument, options);
      }
export function useEmailMarketingUnsubscribePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingUnsubscribePageQuery, EmailMarketingUnsubscribePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingUnsubscribePageQuery, EmailMarketingUnsubscribePageQueryVariables>(EmailMarketingUnsubscribePageDocument, options);
        }
export type EmailMarketingUnsubscribePageQueryHookResult = ReturnType<typeof useEmailMarketingUnsubscribePageQuery>;
export type EmailMarketingUnsubscribePageLazyQueryHookResult = ReturnType<typeof useEmailMarketingUnsubscribePageLazyQuery>;
export type EmailMarketingUnsubscribePageQueryResult = Apollo.QueryResult<EmailMarketingUnsubscribePageQuery, EmailMarketingUnsubscribePageQueryVariables>;
export const EmailMarketingFormPrefillDataDocument = gql`
    query EmailMarketingFormPrefillData($uid: ID!, $emsUserToken: String!) {
  emailMarketingFormPrefillData(uid: $uid, emsUserToken: $emsUserToken) {
    entries {
      ...FormPrefillEntry
    }
  }
}
    ${FormPrefillEntryFragmentDoc}`;

/**
 * __useEmailMarketingFormPrefillDataQuery__
 *
 * To run a query within a React component, call `useEmailMarketingFormPrefillDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailMarketingFormPrefillDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMarketingFormPrefillDataQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      emsUserToken: // value for 'emsUserToken'
 *   },
 * });
 */
export function useEmailMarketingFormPrefillDataQuery(baseOptions: Apollo.QueryHookOptions<EmailMarketingFormPrefillDataQuery, EmailMarketingFormPrefillDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMarketingFormPrefillDataQuery, EmailMarketingFormPrefillDataQueryVariables>(EmailMarketingFormPrefillDataDocument, options);
      }
export function useEmailMarketingFormPrefillDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailMarketingFormPrefillDataQuery, EmailMarketingFormPrefillDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMarketingFormPrefillDataQuery, EmailMarketingFormPrefillDataQueryVariables>(EmailMarketingFormPrefillDataDocument, options);
        }
export type EmailMarketingFormPrefillDataQueryHookResult = ReturnType<typeof useEmailMarketingFormPrefillDataQuery>;
export type EmailMarketingFormPrefillDataLazyQueryHookResult = ReturnType<typeof useEmailMarketingFormPrefillDataLazyQuery>;
export type EmailMarketingFormPrefillDataQueryResult = Apollo.QueryResult<EmailMarketingFormPrefillDataQuery, EmailMarketingFormPrefillDataQueryVariables>;
export const FormDocument = gql`
    query Form($uid: ID!, $version: FormVersionEnum!) {
  form(uid: $uid, version: $version) {
    ...FormInfo
  }
  ff_release_13_form_footer_links_new_tab: featureEnabled(
    name: "ff_release_13_form_footer_links_new_tab"
  )
}
    ${FormInfoFragmentDoc}`;

/**
 * __useFormQuery__
 *
 * To run a query within a React component, call `useFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useFormQuery(baseOptions: Apollo.QueryHookOptions<FormQuery, FormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormQuery, FormQueryVariables>(FormDocument, options);
      }
export function useFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQuery, FormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormQuery, FormQueryVariables>(FormDocument, options);
        }
export type FormQueryHookResult = ReturnType<typeof useFormQuery>;
export type FormLazyQueryHookResult = ReturnType<typeof useFormLazyQuery>;
export type FormQueryResult = Apollo.QueryResult<FormQuery, FormQueryVariables>;
export const SubmitFormDocument = gql`
    mutation SubmitForm($formId: ID!, $version: PublicFormVersion, $inputs: [PublicFormElementInput!]!, $recaptchaResponse: String!) {
  submitForm(
    formId: $formId
    version: $version
    inputs: $inputs
    recaptchaResponse: $recaptchaResponse
  ) {
    failReasons
    form {
      waitlistSettings {
        redirectUrl
        redirectRequired
      }
    }
  }
}
    `;
export type SubmitFormMutationFn = Apollo.MutationFunction<SubmitFormMutation, SubmitFormMutationVariables>;

/**
 * __useSubmitFormMutation__
 *
 * To run a mutation, you first call `useSubmitFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFormMutation, { data, loading, error }] = useSubmitFormMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      version: // value for 'version'
 *      inputs: // value for 'inputs'
 *      recaptchaResponse: // value for 'recaptchaResponse'
 *   },
 * });
 */
export function useSubmitFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFormMutation, SubmitFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFormMutation, SubmitFormMutationVariables>(SubmitFormDocument, options);
      }
export type SubmitFormMutationHookResult = ReturnType<typeof useSubmitFormMutation>;
export type SubmitFormMutationResult = Apollo.MutationResult<SubmitFormMutation>;
export type SubmitFormMutationOptions = Apollo.BaseMutationOptions<SubmitFormMutation, SubmitFormMutationVariables>;